// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1fZji","img":"Header_img__OXgVA","btn":"Header_btn__TS68y"};